import React, { useState } from 'react';
import { Search, ArrowLeft, X } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const isDetailPage = location.pathname.includes('/article/') || location.pathname.includes('/video/');
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
      setShowSearchModal(false);
      setSearchQuery(''); // Clear search input after navigation
    }
  };

  return (
    <header className="header">
      {isDetailPage ? (
        <button onClick={() => navigate(-1)} className="back-button">
          <ArrowLeft size={24} />
        </button>
      ) : (
        <button onClick={() => navigate('/')} className="logo-button">
          <img src="/mp-logo.png" alt="Logo" className="logo" />
        </button>
      )}
      <div className="search-icon" onClick={() => setShowSearchModal(true)}>
        <Search size={24} />
      </div>

      {showSearchModal && (
        <div className="search-modal">
          <button className="close-search" onClick={() => setShowSearchModal(false)}>
            <X size={24} />
          </button>
          <form onSubmit={handleSearch} className="search-container">
            <input
              type="text"
              placeholder="Search by title, tags, or type 'video'"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </form>
        </div>
      )}
    </header>
  );
}

export default Header;
